import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { get } from "../http/api";
import ApplyOfferModal from "./ApplyOfferModal";
import './OfferDetails.css'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";



export default function OfferDetails() {

    const { id } = useParams();
    const [offer, setOffer] = useState(null);
    const isClosed = offer?.status === "closed";
    const [loading, setLoading] = useState(true);
    const [showApply, setShowApply] = useState(false);

    const navigate = useNavigate();

    const { t } = useTranslation();



    useEffect(() => {
        fetchOffer();
    }, []);

    const fetchOffer =
        async () => {

            try {

                const res =
                    await get(
                        `offers/${id}`
                    );

                setOffer(
                    res.data
                );

            }
            catch (err) {

                console.log(
                    err
                );

            }
            finally {

                setLoading(
                    false
                );

            }

        };

    if (
        loading
    ) {

        return (
            <div>
                {t("offerDetails.loading")}
            </div>
        );

    }

    if (
        !offer
    ) {

        return (
            <div>
                {t("offerDetails.notFound")}
            </div>
        );

    }

    return (

        <div className="offer-page">

            <button
                className="sport-back-btn"
                onClick={() => navigate(-1)}
                style={{ marginBottom: "20px" }}
            >
                <span className="back-arrow">←</span>

                <div className="back-content">
                    <span className="back-label">
                        {t("offerDetails.back.label")}
                    </span>

                    <small>
                        {t("offerDetails.back.subtitle")}
                    </small>
                </div>
            </button>

            <div className="offer-header">

                <div className="offer-avatar">

                    {offer.image ? (

                        <img
                            src={getMediaUrl(offer.image)}
                            // src={`${UPLOADS_URL}/${offer.image}`}
                            alt=""
                        />

                    ) : (

                        <span>⚽</span>

                    )}

                </div>

                <div className="offer-header-info">

                    <div className="offer-active">
                        {t("offerDetails.status.active")}
                    </div>

                    <h1>

                        {offer.title}

                    </h1>

                    <p>

                        @{offer.username}
                    </p>

                </div>

            </div>


            <div className="offer-content">

                <div className="offer-card">

                    <h2>
                        {t("offerDetails.sections.description")}
                    </h2>

                    <p>

                        {offer.description}

                    </p>

                </div>


                <div className="offer-card">

                    <h2>
                        {t("offerDetails.sections.profile")}
                    </h2>

                    {offer.filters_json && (

                        <div className="offer-profile-grid">

                            {Object.entries(
                                JSON.parse(
                                    offer.filters_json
                                )
                            ).map(

                                ([key, value]) =>

                                    value && (

                                        <div
                                            className="profile-item"
                                            key={key}
                                        >

                                            <span>

                                                {key
                                                    .replaceAll(
                                                        "_",
                                                        " "
                                                    )}

                                            </span>

                                            <strong>

                                                {value}

                                            </strong>

                                        </div>

                                    )

                            )}

                        </div>

                    )}

                </div>


                {

                    isClosed ? (

                        <div
                            className="role-warning"
                        >
                            {t("offerDetails.warnings.offerSuspended")}
                        </div>

                    )

                        :

                        !offer.isCompatible && (

                            <div
                                className="role-warning"
                            >
                                {t("offerDetails.warnings.notCompatible")}
                            </div>

                        )

                }

                <button

                    className={`offer-apply-btn ${(!offer.isCompatible || isClosed)
                        ? "disabled"
                        : ""
                        }`}

                    disabled={
                        !offer.isCompatible ||
                        isClosed
                    }

                    onClick={() => {

                        if (
                            offer.isCompatible &&
                            !isClosed
                        ) {

                            setShowApply(true);

                        }

                    }}

                >

                    {

                        isClosed
                            ?

                            t("offerDetails.buttons.suspended")

                            :

                            t("offerDetails.buttons.apply")

                    }

                </button>

            </div>

            <ApplyOfferModal
                open={showApply}
                onClose={() => setShowApply(false)}
                offerId={id}
            />

        </div>

    )

}